// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

#statusContainer {
  position: absolute;
  bottom: 0px;
  z-index: 100;
  background-color: #808080;
  color: white;
  margin: 0px;
  padding: 0px;
  font: 10pt sans-serif;
}

#statusContainer li {
  width: 100vw;
  max-height: 25vh;
  overflow-y: auto;
}

.neuroglancer-status-header {
  display: inline-block;
  font: 10pt sans-serif;
  font-weight: bold;
  background-color: #333;
  padding: 2px;
}

#statusContainerModal {
  pointer-events: none;
  position: absolute;
  z-index: 100;
  color: white;
  margin: 0px;
  padding: 0px;
  font: 10pt sans-serif;

  display: grid;
  align-content: center;
  justify-content: center;
  height: 100vh;
  width: 80vw;
  left: 10vw;
  grid-row-gap: 10px;
}

#statusContainerModal > div {
  pointer-events: initial;
  position: relative;
  background-color: #808080;
  padding: 20px;
  padding-top: 30px;
}

#statusContainerModal > div > div:first-child {
  position: absolute;
  top: 4px;
  right: 4px;
  margin: 0;
  padding: 0;
}

#statusContainerModal li {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/status.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/**\n * @license\n * Copyright 2016 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n#statusContainer {\n  position: absolute;\n  bottom: 0px;\n  z-index: 100;\n  background-color: #808080;\n  color: white;\n  margin: 0px;\n  padding: 0px;\n  font: 10pt sans-serif;\n}\n\n#statusContainer li {\n  width: 100vw;\n  max-height: 25vh;\n  overflow-y: auto;\n}\n\n.neuroglancer-status-header {\n  display: inline-block;\n  font: 10pt sans-serif;\n  font-weight: bold;\n  background-color: #333;\n  padding: 2px;\n}\n\n#statusContainerModal {\n  pointer-events: none;\n  position: absolute;\n  z-index: 100;\n  color: white;\n  margin: 0px;\n  padding: 0px;\n  font: 10pt sans-serif;\n\n  display: grid;\n  align-content: center;\n  justify-content: center;\n  height: 100vh;\n  width: 80vw;\n  left: 10vw;\n  grid-row-gap: 10px;\n}\n\n#statusContainerModal > div {\n  pointer-events: initial;\n  position: relative;\n  background-color: #808080;\n  padding: 20px;\n  padding-top: 30px;\n}\n\n#statusContainerModal > div > div:first-child {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  margin: 0;\n  padding: 0;\n}\n\n#statusContainerModal li {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
